<nav>
  <div>
    <img src="../../../assets/img/auri_logo.png" alt="" height="60px">
    <a href="/cliente/inicio">Inicio</a>
    <a>Mi pedido</a>
    <a href="/cliente/paquetes">Paquetes</a>
    <a href="/cliente/proceso-v2">Como funciona?</a>
    <a href="/cliente/realizar-pago">Comprobante</a>
  </div>
  
  <div>
    <a>Mi cuenta</a>
  </div>
</nav>

<div class="bg-yellow">
    <div class="libreta">

        <div class="d-flex" style="position: inherit; z-index: 10;">
            <p class="bg-dark text-white p-2 rounded">Seguimiento de mi pedido</p>
        </div>

        <div class="steps">
            <div class="step" *ngFor="let step of steps">
                <span class="circle" [ngClass]="{ 'bg_disable': !step.completed }"></span>
                <p class="m-0 p-0" [ngClass]="{ disable: !step.completed }">{{ step.label }}</p>
            </div>
        </div>

        <div class="mb-5" style="position: inherit; z-index: 10;">

            <div class="row d-flex justify-content-around">
                <div class="col-md-4 col-sm-12 mt-5 p-3 rounded" style="border: 1px solid black; background: #F2F2F2;">
                    <h5 class="mt-3 mb-5">Resumen de pedido</h5>
                    <div *ngIf="resumen.length; else sinResumen">
                        <h6 class="mb-3" *ngFor="let item of resumen">{{ item.paquete }}</h6>
                    </div>
                    <ng-template #sinResumen>
                        <p>Todavia no seleccionas un paquete.</p>
                    </ng-template>
                </div>
                <div class="col-md-4 col-sm-12 mt-5 p-3">
                    <div class="warning-message mt-5">
                        <img src="../../../assets/img/warning-logo.png" alt="" width="30px">
                        {{ advertencia }}
                    </div>
                </div>
            </div>
        </div>          

    </div>
</div>
